<template>
    <div class='row'>
        <div class='selected-facets col-xs-12'>
            <div v-for='filter in manager.formattedForDisplay()'>
                <span class='label label-default pull-left'>
                    <div class='facet-text'>
                        {{ manager.cleanHtml(filter.value) }}
                    </div>
                    <img class='clickable facet-x'
                        src="/images/X_small_dkGrey.svg"
                        @click='manager.removeByField(filter.field, filter.value)'>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import FilterManager from './../filterManager.js'

    export default {
        data: function () {
            return {
                manager: FilterManager,
            }
        }
    }
</script>

<style lang='scss' scoped>
    @import '../../../sass/variables.scss';

    .row {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .selected-facets .label {
        background-color: $light_gray;
        color: black;
        padding: 7px;
        margin-bottom: 10px;
        margin-right: 10px;

        .facet-x {
            margin-left: 5px;
        }

        .facet-text {
            display: inline-block;
            max-width: 300px;
            height: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            vertical-align: middle;
        }
    }
</style>
